import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import "./Insights.css";


const sidebarLinks = [
  { label: "Blogs", path: "/thinking/blogs" },
  { label: "Whitepapers", path: "/thinking/whitepapers" },
  { label: "Case Studies", path: "/thinking/case-studies" },

];

export default function Insights() {
  const location = useLocation();
  const isRoot =
    location.pathname === "/about" || location.pathname === "/about/";

  return (
    <div className="about-layout">
      {/* ── Sidebar ── */}
      <aside className="about-sidebar">
        <p className="about-sidebar__heading">Insights</p>
        <nav className="about-sidebar__nav">
          {sidebarLinks.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                isActive
                  ? "about-sidebar__link about-sidebar__link--active"
                  : "about-sidebar__link"
              }
            >
              <span className="about-sidebar__dot" />
              {link.label}
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* ── Main content ── */}
      <main className="ins-main">
        {isRoot ? <Navigate to="/about/vision" replace /> : <Outlet />}
      </main>
    </div>
  );
}